var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.2 4.48C8.81.33 15.22.33 18.82 4.48h-.01c3.13 3.61 2.7 9.11-.68 12.49L12.8 22.3c-.44.44-1.15.44-1.59 0l-5.33-5.33C2.5 13.59 2.07 8.09 5.2 4.48Zm9.81 5.89a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  fill: "currentColor"
})));
export default SvgIcLocation;